module.exports = __webpack_public_path__ + "static/media/dartboards.7a5dff3b.svg";